import AccountCreation from "@/components/signup/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { RovoDevAgentsLogo } from "@/components/signup/utils";

import { RovoDevGetStartedHeading } from "../../components/get-started-heading";

export const LoggedOutRovoDevStandard = () => {
    return (
        <SignupBackgroundLayout
            theme="green"
            ProductLogo={<RovoDevAgentsLogo />}
        >
            <RovoDevGetStartedHeading />
            <AccountCreation />
        </SignupBackgroundLayout>
    );
};
